import type { Role } from '@crm/shared'

/**
 * Что роль видит и может в списке заявок (вынесено из RequestsPage.tsx 29.09.2026 —
 * файл превысил лимит 500 строк).
 */
export function requestsRoleFlags(role: Role | string | undefined) {
  const is = (...roles: string[]) => role !== undefined && roles.includes(role)
  return {
    // Удалить заявку и восстановить из корзины. Помощник — с 29.09.2026, сервер
    // пускает его только к заявкам прикреплённых менеджеров.
    canDelete: is('ADMIN', 'MANAGER', 'ROP', 'ASSISTANT'),
    // Колонку «Менеджер» видят те, кому важно, чей это клиент/заявка.
    showManagerColumn: is('ADMIN', 'GENERAL_DIRECTOR', 'ROP', 'ASSISTANT'),
    isProcurement: is('PROCUREMENT'),
    isSalesView: is('ADMIN', 'GENERAL_DIRECTOR', 'MANAGER', 'ROP', 'ASSISTANT'),
    // РОЗ делит список как админ: активные + «Обработанные» (Счёт/Архив; Отказ
    // РОЗ не видит). Сводка /requests/summary ему недоступна (RBAC) — счётчик
    // обработанных берётся из загруженных строк (fallback в ProcessedSummaryLabel).
    isRosView: is('ROS'),
  }
}
